import { PresetTag, SoftTag } from '../../components/Tag/SoftTag';
import { L } from '@lib';
import { Tag } from 'antd';

export const LocalizedMasterBuildStatus = {
  Draft: L('Draft'),
  Active: L('Active'),
  OnHold: L('On hold'),
  Completed: L('Completed'),
  Canceled: L('Canceled'),
};

const tagStyle = { minWidth: 100, textAlign: 'center' as const };

/** The build's own lifecycle, set by the garage. */
export const MasterBuildStatusTag = {
  Draft: <PresetTag color="default" style={tagStyle}>Draft</PresetTag>,
  Active: <SoftTag group="blue" style={tagStyle}>Active</SoftTag>,
  OnHold: <SoftTag group="yellow" style={tagStyle}>On hold</SoftTag>,
  Completed: <SoftTag group="green" style={tagStyle}>Completed</SoftTag>,
  Canceled: <SoftTag group="danger" style={tagStyle}>Canceled</SoftTag>,
};

/**
 * Progress across the build's jobs, derived by the API rather than set by anyone - so it is shown
 * in a quieter, borderless style than the status above to keep the two apart at a glance.
 */
export const MasterBuildProgressTag = {
  Empty: <Tag style={tagStyle}>No jobs</Tag>,
  NotStarted: <PresetTag color="default" style={tagStyle}>Not started</PresetTag>,
  InProgress: <SoftTag group="blue" style={tagStyle}>In progress</SoftTag>,
  Completed: <SoftTag group="green" style={tagStyle}>All done</SoftTag>,
};

export type MasterBuildStatusTagObjectKey = keyof typeof MasterBuildStatusTag;
export type MasterBuildProgressTagObjectKey = keyof typeof MasterBuildProgressTag;
export type LocalizedMasterBuildStatusObjectKey = keyof typeof LocalizedMasterBuildStatus;
